import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconMute: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconMute"><Path fillRule="evenodd" clipRule="evenodd" d="M3.50008 21.2072L21.2072 3.50008L20.5001 2.79297L17 6.29305V2.88477L9.86611 7.00047H5V17.0005H6.29257L2.79297 20.5001L3.50008 21.2072ZM7.29257 16.0005H6V8.00047H10.1339L16 4.61618V7.29305L7.29257 16.0005Z" fill="currentColor"/><Path d="M10.1339 16.0005H10.1215L9.12155 17.0005H9.86611L17 21.1162V9.12202L16 10.122V19.3848L10.1339 16.0005Z" fill="currentColor"/></CentralIconBase>;
});

export default IconMute;
